/* eslint-disable react/jsx-props-no-spreading */
import PropTypes from 'prop-types';
import Tippy from '@aslakson/tippyjs-react';

// Utils & misc
import { cn } from 'utils';

// Style
import style from './Tooltip.module.css';

export function Tooltip({
  placement,
  content,
  children,
  arrow,
  visible,
  isTriggered,
  tooltipBoxStyle,
  className,
  ...props
}) {
  return (
    <Tippy
      trigger={content && 'mouseenter'}
      arrow={arrow}
      content={(
        isTriggered ? (
          <div
            style={tooltipBoxStyle}
            className={cn([style.tooltipBox, arrow ? style.arrow : '', className])}
            data-placement={placement}
          >
            {content}
            {arrow ? <div className={style.arrow} data-popper-arrow="" /> : null}
          </div>
        ) : null
      )}
      placement={placement}
      {...props}
    >
      {children}
    </Tippy>
  );
}

Tooltip.propTypes = {
  placement: PropTypes.oneOf([
    'top',
    'top-start',
    'top-end',
    'right',
    'right-start',
    'right-end',
    'bottom',
    'bottom-start',
    'bottom-end',
    'left',
    'left-start',
    'left-end',
  ]),
  arrow: PropTypes.bool,
  visible: PropTypes.bool,
  isTriggered: PropTypes.bool,
  content: PropTypes.node.isRequired,
  tooltipBoxStyle: PropTypes.shape({}),
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

Tooltip.defaultProps = {
  placement: 'bottom',
  visible: false,
  isTriggered: true,
  arrow: false,
  className: '',
  tooltipBoxStyle: {},
};

export default Tooltip;
